module.exports = __webpack_public_path__ + "static/img/16.9a9fe2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/16.png
// module id = IvrY
// module chunks = 0